import {
  API_CALL_WIZARD_API_REQUEST,
  API_CALL_WIZARD_API_SUCCESS,
  API_CALL_WIZARD_API_ERROR,
  SEARCH_CALL_WIZARD_API_REQUEST,
  SEARCH_CALL_WIZARD_API_SUCCESS,
  SEARCH_CALL_WIZARD_API_ERROR,
  ADD_INITIAL_WIZARD_DATA_SUCCESS,
  EMPTY_INITIAL_WIZARD_DATA_SUCCESS,
  ADD_LAST_ENTRY_POINT_SUCCESS,
  RESET_WIZARD_DATA_SUCCESS,
  RESET_WIZARD_SUCCESS,
  RESET_WIZARD_FIELDS_ONCHANGE,
  GET_WIZARD_API_REQUEST,
  GET_WIZARD_API_SUCCESS,
  GET_WIZARD_API_ERROR,
  GET_MODAL_WIZARD_API_REQUEST,
  GET_MODAL_WIZARD_API_SUCCESS,
  GET_MODAL_WIZARD_API_ERROR,
  LOADING_WIZARD_SUCCESS,
  ADD_LOCAL_WIZARD_SUCCESS,
  ADD_LOCAL_MODAL_WIZARD_SUCCESS,
  RESET_WIZARD_FLAG_SUCCESS,
  SET_API_CALL_PENDING,
  SET_MODAL_API_CALL_PENDING,
  ADD_MODAL_WIZARD_SLUG_SUCCESS,
  RESET_MODAL_WIZARD_SLUG_SUCCESS,
  RESET_APICALL_WIZARD_RESPONSE,
  SET_CHECKBOX_STATE,
  DUTCH_API_CALL_WIZARD_API_SUCCESS,
  DUTCH_API_CALL_WIZARD_API_ERROR,
} from '../../constants/wizardActionNames';
import {
  SELECT_CLIENTS_SUCCESS,
  SIGNIN_API_SUCCESS,
} from '../../constants/authActionNames';

// import lobTypes from '../../utils/variables/lobTypes.json';
import { statusOk, persistKey } from '../../utils/variables';
import {
  checkComponent,
  transformReducerValue,
} from '../../componentsV2/wizards/functions';
import {
  createAccountsPayload,
  updateHoldingsWithCalculations,
} from '../portfolio/investments';
import { createPolicies, createCustomPolicies } from '../portfolio/insurance';
import {
  mergeArraysDeep,
  addItemOnce,
  mergeDeep,
  getRef,
  setRef,
  sourceTextFromData,
  transformConditionalValue,
  dateToString,
  stringToDate,
  dateToReadableString,
  isCurrentMonth,
} from '../../utils/functions';

import { createPartialClaim } from '../../utils/functions/backend-to-frontend-mappers/claims';
import { createPrecerts } from '../../utils/functions/backend-to-frontend-mappers/claims/precerts';
import { createPartialPayanything } from '../../utils/functions/backend-to-frontend-mappers/claims/createMakePayment';
import { createApplication } from '../../utils/functions/backend-to-frontend-mappers/applications';

const DERIVED_REFERRED_TO_VALUE = 'Underwriter';
const BACK_OFFICE_REFERRED_TO_VALUE = 'Back Office';
const CC_REFERRED_TO_THRESHOLD = 3501;
// Loading rule constants
const CC_LOADING_THRESHOLD = 3500; // inclusive threshold per product rule
const UNDERWRITER_LOADING_CODE = 'UND';
const UNDERWRITER_LOADING_PERCENT = 25;

const normalizeString = value => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object') {
    if (Object.prototype.hasOwnProperty.call(value, 'value')) {
      return normalizeString(value.value);
    }
    if (Object.prototype.hasOwnProperty.call(value, 'title')) {
      return normalizeString(value.title);
    }
  }
  return value.toString().trim().toLowerCase();
};

const stringEquals = (value, target) =>
  normalizeString(value) === normalizeString(target);

const toNumber = value => {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') {
    return Number.isNaN(value) ? null : value;
  }
  if (typeof value === 'object') {
    if (Object.prototype.hasOwnProperty.call(value, 'value')) {
      return toNumber(value.value);
    }
    if (Object.prototype.hasOwnProperty.call(value, 'title')) {
      return toNumber(value.title);
    }
  }
  const normalized = value
    .toString()
    .replace(/,/g, '')
    .replace(/[^0-9.-]/g, '');
  if (!normalized) return null;
  const num = Number(normalized);
  return Number.isNaN(num) ? null : num;
};

export const deriveReferredToFromWizardData = wizardData => {
  if (!wizardData) return null;

  const country = (wizardData.COUNTRY || '').toString().trim().toUpperCase();
  if (country && country !== 'TT') return DERIVED_REFERRED_TO_VALUE;

  if (stringEquals(wizardData.isPoliticallyExposed, 'yes')) return DERIVED_REFERRED_TO_VALUE;
  if (stringEquals(wizardData.gender, 'C')) return DERIVED_REFERRED_TO_VALUE;

  const vehicleLabel = normalizeString(
    wizardData?.vehicle?.label || wizardData?.vehicleLabel || wizardData?.vehicleName,
  );
  if (vehicleLabel.includes('aqua')) return DERIVED_REFERRED_TO_VALUE;

  // NOTE: Removed automatic referral based solely on cubic capacity.
  // Previous behaviour checked CubicCapacityRating / vehicleCC / ccRating and
  // returned `DERIVED_REFERRED_TO_VALUE` when any value >= CC_REFERRED_TO_THRESHOLD.
  // That made the global 'Underwriter' (non-STP) alert appear whenever CC was high.
  // Intentionally skip that check here to avoid triggering a global referral from
  // cubic capacity alone. If business rules change, reintroduce with additional
  // gating conditions (e.g., vehicle age, usage, or explicit flag).

  const seatCount = toNumber(
    wizardData?.NumberofSeats || wizardData?.numberOfSeats || wizardData?.seatCount,
  );
  if (seatCount !== null && seatCount > 7) {
    return BACK_OFFICE_REFERRED_TO_VALUE;
  }

  const vehicleValue = toNumber(
    wizardData?.vehicleValue ||
    wizardData?.number_vehicleValue ||
    wizardData?.formatted_vehicleValue ||
    wizardData?.sumInsured ||
    wizardData?.marketValue,
  );
  if (vehicleValue !== null && (vehicleValue <= 30000 || vehicleValue >= 600000)) {
    return DERIVED_REFERRED_TO_VALUE;
  }

  if (stringEquals(wizardData?.hasAlarm, 'no')) {
    return DERIVED_REFERRED_TO_VALUE;
  }

  if (stringEquals(wizardData?.vehicleUsage, 'commercial')) {
    return DERIVED_REFERRED_TO_VALUE;
  }

  if (stringEquals(wizardData?.previousPolicyDeclined, 'yes')) {
    return DERIVED_REFERRED_TO_VALUE;
  }

  if (stringEquals(wizardData?.warrantyConfirmation, 'no')) {
    return DERIVED_REFERRED_TO_VALUE;
  }

  if (stringEquals(wizardData?.vehicleCondition, 'no')) {
    return DERIVED_REFERRED_TO_VALUE;
  }




  const vehicleManufactureYear = toNumber(
    wizardData?.vehicleManufactureYear ||
    wizardData?.vehicleYear ||
    wizardData?.yearOfManufacture ||
    wizardData?.vehicleManufactureYear?.value,
  );
  if (vehicleManufactureYear !== null) {
    const currentYear = new Date().getFullYear();
    const vehicleAge = currentYear - vehicleManufactureYear;
    if (vehicleAge >= 20) {
      return DERIVED_REFERRED_TO_VALUE;
    }
  }
  const insuranceYears = toNumber(wizardData?.insuranceYears);
  const claimYearsAgo = toNumber(
    wizardData?.claimYearsAgo || wizardData?.auth?.selectedClient?.claimYearsAgo,
  );
  if ([insuranceYears, claimYearsAgo].some(value => value === 1 || value === 2)) {
    return DERIVED_REFERRED_TO_VALUE;
  }

  const dobAgeCategory = normalizeString(wizardData?.dobAgeCategory);
  if (dobAgeCategory && dobAgeCategory !== 'stp') {
    return DERIVED_REFERRED_TO_VALUE;
  }

  const driversPermitCountry = normalizeString(
    wizardData?.driversPermitCountry_countryFullName ||
    wizardData?.driversPermitCountryCountryFullName ||
    wizardData?.driversPermitCountry,
  );
  if (
    driversPermitCountry &&
    !['trinidad and tobago', 'trinidad & tobago'].includes(driversPermitCountry)
  ) {
    return DERIVED_REFERRED_TO_VALUE;
  }

  if (stringEquals(wizardData.vehicleModified, 'yes')) return DERIVED_REFERRED_TO_VALUE;
  if (stringEquals(wizardData.vehicleOnlyRegisteredOwner, 'no')) return DERIVED_REFERRED_TO_VALUE;

  // Motor TT rule: Comprehensive is not allowed for vehicles >= 12 years old.
  // If user selected Comprehensive and the vehicle's age is 12+ years, treat as non‑STP.
  // (UI will display the underwriter alert/popup based on `referredTo`.)
  const selectedCoverageType = (wizardData?.vehicleCoverageType || '')
    .toString()
    .trim()
    .toUpperCase();
  const vehicleAge =
    toNumber(wizardData?.vehicleAge) ?? deriveVehicleAgeFromWizardData(wizardData);
  if (selectedCoverageType === 'C' && vehicleAge !== null && vehicleAge >= 12) {
    return DERIVED_REFERRED_TO_VALUE;
  }

  // Motor TT rule: Third Party, Fire & Theft is not allowed for vehicles >= 15 years old.
  // Treat as non‑STP.
  if (selectedCoverageType === 'F' && vehicleAge !== null && vehicleAge >= 15) {
    return DERIVED_REFERRED_TO_VALUE;
  }

  // Motor TT rule: if policy excess acknowledgement is displayed and the user
  // does not accept it, route the application to underwriting.
  if (
    selectedCoverageType &&
    selectedCoverageType !== 'T' &&
    wizardData.policyExcessAccepted === false
  ) {
    return DERIVED_REFERRED_TO_VALUE;
  }

  return null;
};

/**
 * Determine whether underwriter loading should be applied based on cubic capacity.
 * Returns an object with keys to be merged into wizard state, or null if not applicable.
 */
const deriveUnderwriterLoadingFromWizardData = wizardData => {
  if (!wizardData) return null;

  const ccValues = [
    wizardData?.CubicCapacityRating,
    wizardData?.vehicleCC,
    wizardData?.ccRating,
  ].map(toNumber);

  const hasHighCC = ccValues.some(value => value !== null && value >= CC_LOADING_THRESHOLD);
  if (hasHighCC) {
    return {
      underwriterLoadingCode: UNDERWRITER_LOADING_CODE,
      underwriterLoadingPercent: UNDERWRITER_LOADING_PERCENT,
    };
  }

  return null;
};

const deriveVehicleAgeFromWizardData = wizardData => {
  if (!wizardData) return null;
  const vehicleManufactureYear = toNumber(
    wizardData?.vehicleManufactureYear ||
    wizardData?.vehicleYear ||
    wizardData?.yearOfManufacture ||
    wizardData?.vehicleManufactureYear?.value,
  );
  if (vehicleManufactureYear === null || vehicleManufactureYear === undefined) return null;

  const currentYear = new Date().getFullYear();
  if (vehicleManufactureYear > currentYear) return null;
  return currentYear - vehicleManufactureYear;
};

// Specific non-STP helper flag for Motor TT coverage selection rules.
// This is intentionally separate from `referredTo` so wizard JSON can show
// a more targeted message/popup without coupling to the generic Underwriter alert.
const deriveMotorComprehensiveNotAllowedByAge = wizardData => {
  if (!wizardData) return false;
  const selectedCoverageType = (wizardData?.vehicleCoverageType || '')
    .toString()
    .trim()
    .toUpperCase();
  const vehicleAge = toNumber(wizardData?.vehicleAge) ?? deriveVehicleAgeFromWizardData(wizardData);
  return selectedCoverageType === 'C' && vehicleAge !== null && vehicleAge >= 12;
};

const deriveMotorFireAndTheftNotAllowedByAge = wizardData => {
  if (!wizardData) return false;
  const selectedCoverageType = (wizardData?.vehicleCoverageType || '')
    .toString()
    .trim()
    .toUpperCase();
  const vehicleAge = toNumber(wizardData?.vehicleAge) ?? deriveVehicleAgeFromWizardData(wizardData);
  return selectedCoverageType === 'F' && vehicleAge !== null && vehicleAge >= 15;
};

const applyDerivedReferredTo = wizardData => {
  if (!wizardData) return wizardData;
  let nextData = wizardData;
  const vehicleAge = deriveVehicleAgeFromWizardData(wizardData);
  if (vehicleAge !== null && vehicleAge !== wizardData.vehicleAge) {
    nextData = { ...nextData, vehicleAge };
  }
  if (vehicleAge === null && wizardData.vehicleAge !== undefined) {
    nextData = { ...nextData };
    delete nextData.vehicleAge;
  }

  // Derived helper flag used by UI conditions
  const motorComprehensiveNotAllowedByAge =
    deriveMotorComprehensiveNotAllowedByAge(nextData);
  if (motorComprehensiveNotAllowedByAge !== nextData.motorComprehensiveNotAllowedByAge) {
    nextData = { ...nextData, motorComprehensiveNotAllowedByAge };
  }

  const motorFireAndTheftNotAllowedByAge =
    deriveMotorFireAndTheftNotAllowedByAge(nextData);
  if (motorFireAndTheftNotAllowedByAge !== nextData.motorFireAndTheftNotAllowedByAge) {
    nextData = { ...nextData, motorFireAndTheftNotAllowedByAge };
  }
  if (nextData.referredToSource === 'server') {
    return nextData;
  }

  // Derived underwriter loading (set/remove keys underwriterLoadingCode/Percent)
  const derivedLoading = deriveUnderwriterLoadingFromWizardData(nextData);
  if (derivedLoading) {
    const { underwriterLoadingCode, underwriterLoadingPercent } = derivedLoading;
    if (
      nextData.underwriterLoadingCode !== underwriterLoadingCode ||
      nextData.underwriterLoadingPercent !== underwriterLoadingPercent
    ) {
      nextData = {
        ...nextData,
        underwriterLoadingCode,
        underwriterLoadingPercent,
      };
    }
  } else if (
    nextData.underwriterLoadingCode !== undefined ||
    nextData.underwriterLoadingPercent !== undefined
  ) {
    // remove previously set derived loading keys when condition no longer applies
    const cleaned = { ...nextData };
    delete cleaned.underwriterLoadingCode;
    delete cleaned.underwriterLoadingPercent;
    nextData = cleaned;
  }

  const derivedValue = deriveReferredToFromWizardData(nextData);
  if (derivedValue) {
    if (
      nextData.referredTo === derivedValue &&
      nextData.referredToSource === 'client'
    ) {
      return nextData;
    }
    return {
      ...nextData,
      referredTo: derivedValue,
      referredToSource: 'client',
    };
  }

  if (nextData.referredToSource === 'client') {
    const cleanedData = { ...nextData };
    delete cleanedData.referredTo;
    delete cleanedData.referredToSource;
    return cleanedData;
  }

  return nextData;
};

export const initialState = {
  apiCallWizardResponse: {},
  isModalApiCallWizardPending: false,
  isApiCallWizardPending: false,
  isApiCallWizardError: false,
  isApiCallWizardSuccess: false,
  apiCallWizardError: null,
  allWizardData: {},
  allInitialWizardData: {},
  initialWizardData: {},
  isLoadingWizard: false,
  getWizardResponse: null,
  isGettingWizardPending: false,
  isGettingWizardError: false,
  isGettingWizardSuccess: false,
  getWizardError: null,
  wizard: null,
  getModalWizardResponse: null,
  isGettingModalWizardPending: false,
  isGettingModalWizardError: false,
  isGettingModalWizardSuccess: false,
  getModalWizardError: null,
  modalWizard: null,
  modalWizardSlug: null,
  searchCallWizardResponse: null,
  isSearchCallWizardPending: false,
  isSearchCallWizardError: false,
  isSearchCallWizardSuccess: false,
  searchCallWizardError: null,
  focusKey: '',
  lastEntryPoint: null,
  resettedWizardData: false,
  resetOnChange: false,
  nextBackButtonLink: null,
  lastAllInitialWizardData: null,
  previousWizardData: {},
};

const formatAccountsPayload = (accounts = [], filter) => {
  return accounts.map(x => {
    // const investmentLobObj = lobTypes.find(x2 => x2.lob === investmentLob);
    // const subType = investmentLobObj?.subTypes.find(x2 => x2.slug === x?.type); subType?.title
    const holdings = x?.holdings?.map(holding => {
      // const newSecurity = holding?.name; // `${holding?.security} - ${holding?.secCode}`;
      return {
        ...holding,
        // security: newSecurity,
        key: 'personal',
        // secCode: holding?.securityCode,
      };
    });

    if (filter) {
      const filteredHoldings = holdings.filter(
        y => y.quantity !== undefined && y.quantity !== null && y.quantity > 0,
      );

      return { ...x, holdings: filteredHoldings };
    }

    return { ...x, holdings };
  });
};

const filterResponsePayload = (payloadArray, filterSetting) => {
  if (!filterSetting) return payloadArray;
  const newPayload = payloadArray.filter(x => {
    const filterKey = filterSetting?.key;
    return filterSetting?.value?.toString() === x[filterKey]?.toString();
  });
  return newPayload;
};

function wizardReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_REFERRED_TO': {
      const nextData = { ...state.allInitialWizardData };
      if (action.payload) {
        nextData.referredTo = action.payload;
        nextData.referredToSource = action?.source || 'client';
      } else {
        delete nextData.referredTo;
        delete nextData.referredToSource;
      }
      return {
        ...state,
        allInitialWizardData: nextData,
      };
    }
    case RESET_APICALL_WIZARD_RESPONSE: {
      const { apiCallWizardResponse } = state;
      const { vehicleModels, manualCatYearInfo, ...rest } = apiCallWizardResponse;
      return {
        ...state,
        apiCallWizardResponse: rest,
      };
    }
    case API_CALL_WIZARD_API_REQUEST: {
      const savedKey = action?.savedKey;

      const initialPendingStatuses = state?.isApiCallWizardPending
        ? state?.isApiCallWizardPending
        : {};
      const initialErrorStatuses = state?.isApiCallWizardError
        ? state?.isApiCallWizardError
        : {};
      const initialSuccessStatuses = state?.isApiCallWizardSuccess
        ? state?.isApiCallWizardSuccess
        : {};

      const newPendingStatuses = {
        ...initialPendingStatuses,
        [savedKey]: true,
      };
      const newSuccessStatuses = { ...initialSuccessStatuses, [savedKey]: false };
      const newErrorStatuses = { ...initialErrorStatuses, [savedKey]: false };
      return {
        ...state,
        isApiCallWizardPending: newPendingStatuses,
        isApiCallWizardError: newErrorStatuses,
        isApiCallWizardSuccess: newSuccessStatuses,
      };
    }
    /*
    case SIGNIN_API_SUCCESS: {
      const user = { ...action?.payload?.payload } || null; // ...state?.user,
      // user.idVerification.canVerify = false;
      if (user.idVerification) {
        if (
          user?.idVerification?.canVerify === false ||
          user?.idVerification?.retryAttemptsExceeded === true
        ) {
          user.idVerification.continueApp = 'false';
        } else {
          user.idVerification.continueApp = 'true';
        }
      }
      const allInitialWizardData = state?.allInitialWizardData;
      allInitialWizardData.onFidoStatus = {
        payload: { idVerification: user?.idVerification },
      };
      const newState = { ...state, allInitialWizardData };
      return newState;
    }
    */

    case API_CALL_WIZARD_API_SUCCESS: {
      let response = action?.payload;
      const savedKey = action?.savedKey;
      const userId = state?.allInitialWizardData?.auth?.userId || 'none';
      let allInitialWizardData = { ...state?.allInitialWizardData };
      const filterSettings = action?.apiCall?.filterSettings;
      const params = action?.params;
      const oldStoreData = action?.oldStoreData;
      const httpMethod = action?.apiCall?.httpMethod;
      const lobTypes = action?.lobTypes;
      const appendKeys = action?.apiCall?.allInitialWizardDataAppendKeys;
      // console.log('action?.apiCall: ', action?.apiCall);
      const verifiedEmailField = action?.apiCall?.verifiedEmailField;

      if (
        httpMethod === 'strapiPost' ||
        httpMethod === 'strapiGet' ||
        !response?.responseType
      ) {
        response = { responseType: 'ok', payload: response };
      }

      const initialResponse = state?.apiCallWizardResponse || {};
      const initialPendingStatuses = state?.isApiCallWizardPending
        ? state?.isApiCallWizardPending
        : {};
      const initialErrorStatuses = state?.isApiCallWizardError
        ? state?.isApiCallWizardError
        : {};
      const initialSuccessStatuses = state?.isApiCallWizardSuccess
        ? state?.isApiCallWizardSuccess
        : {};

      if (savedKey === 'nextAutoPayDate') {
        const nextPaymentDate = dateToReadableString(stringToDate(response?.payload));
        const nextAutoPaymentDate = dateToString(stringToDate(response?.payload));
        const isAutoPayInCurrentMonth = nextAutoPaymentDate
          ? isCurrentMonth(nextAutoPaymentDate)
          : false;

        allInitialWizardData = {
          ...allInitialWizardData,
          nextPaymentDate,
          isAutoPayInCurrentMonth,
          autoPayInCurrentMonthText: isAutoPayInCurrentMonth && ' this month',
        };
      }
      if (savedKey === 'customPolicies') {
        const payloadArray = response?.payload?.policies;

        // const sourceAccount = allInitialWizardData?.sourceAccount;
        // const destinationAccount = allInitialWizardData?.destinationAccount;
        if (Array.isArray(payloadArray)) {
          const newPolicies = createCustomPolicies(payloadArray, lobTypes);
          response.payload.policies = newPolicies;
        }
      }
      if (savedKey === 'insurance') {
        const payloadArray = response?.payload?.result?.data;

        // const sourceAccount = allInitialWizardData?.sourceAccount;
        // const destinationAccount = allInitialWizardData?.destinationAccount;
        if (Array.isArray(payloadArray)) {
          const newPolicies = createPolicies(payloadArray, lobTypes);
          response.payload.policies = newPolicies;
        }
      }
      if (savedKey === 'policiesByLob') {
        const payloadArray = response?.payload?.policies;

        // const sourceAccount = allInitialWizardData?.sourceAccount;
        // const destinationAccount = allInitialWizardData?.destinationAccount;
        if (Array.isArray(payloadArray)) {
          const newPolicies = createPolicies(payloadArray, lobTypes);
          response.payload.policies = newPolicies;
        }
      }

      if (savedKey === 'accountCalculations') {
        const accountCalculation = response?.payload;
        const initialAccounts = state?.allInitialWizardData?.accounts || []; // oldStoreData.accounts ||
        // // console.log('initialAccounts: ', initialAccounts);

        const formatAccounts = updateHoldingsWithCalculations(
          initialAccounts,
          initialAccounts,
          accountCalculation,
          params,
        );
        const accounts = formatAccountsPayload(formatAccounts, true);

        initialResponse.accounts = { ...initialResponse?.accounts, payload: accounts };
        allInitialWizardData.accounts = accounts;
        // // console.log('initialResponse.accounts: ', initialResponse.accounts);
      }

      if (savedKey === 'verificationQuoteEmailConfirm') {
        const boolStatus = response?.responseType === statusOk;
        if (boolStatus) {
          allInitialWizardData.isEmailVerified = true;
          allInitialWizardData.verify_email = allInitialWizardData?.pre_email;
          if (verifiedEmailField)
            allInitialWizardData[verifiedEmailField] = allInitialWizardData?.pre_email;
        }
      }

      if (savedKey === 'verifiedEmailSaved') {
        delete allInitialWizardData.antiForgeryToken;
      }

      // draft home claims pre load
      if (savedKey === 'draftClaim') {
        if (response?.payload?.claim) {
          const wizard = state?.wizard || {};
          allInitialWizardData = {
            ...allInitialWizardData,
            ...createPartialClaim(wizard, response?.payload?.claim || {}),
          };
          // console.log('allInitialWizardData draft claim: ', allInitialWizardData);
        }
      }
      if (savedKey === 'precertDetails') {
        if (response?.payload?._id) {
          const wizard = state?.wizard || {};
          allInitialWizardData = {
            ...allInitialWizardData,
            ...createPrecerts(wizard, response?.payload || {}),
          };
          // console.log('allInitialWizardData draft claim: ', allInitialWizardData);
        }
      }

      if (savedKey === 'cartPayDetails') {
        if (response?.payload?.guestSessionId) {
          const wizard = state?.wizard || {};
          allInitialWizardData = {
            ...allInitialWizardData,
            ...createPartialPayanything(wizard, response?.payload || {}),
          };
        }
      }

      if (savedKey === 'draftApplication') {
        if (response?.payload?.application) {
          const wizard = state?.wizard || {};
          allInitialWizardData = {
            ...allInitialWizardData,
            ...createApplication(wizard, response?.payload?.application || {}),
          };
          // console.log('allInitialWizardData draft claim: ', allInitialWizardData);
        }
      }

      if (filterSettings && filterSettings.length > 0) {
        filterSettings?.map(filterSetting => {
          const payloadArray = getRef(response, filterSetting?.referenceKey) || [];
          const newPayload = filterResponsePayload(payloadArray, filterSetting);
          setRef(response, filterSetting?.referenceKey, newPayload);
        });
      }

      const newResponse = { ...initialResponse, [savedKey]: response };
      const newPendingStatuses = { ...initialPendingStatuses, [savedKey]: false };
      const newSuccessStatuses = { ...initialSuccessStatuses, [savedKey]: true };
      const newErrorStatuses = { ...initialErrorStatuses, [savedKey]: false };

      const allWizardData = {
        ...state.allWizardData,
        [userId]: allInitialWizardData,
      };

      const newState = {
        ...state,
        isApiCallWizardPending: newPendingStatuses,
        isApiCallWizardError: newErrorStatuses,
        isApiCallWizardSuccess: newSuccessStatuses,
        apiCallWizardResponse: newResponse, // newProducts,
        allWizardData,
        allInitialWizardData,
      };

      // If premiumResponse is fetched without sending `referredTo` (conditions false),
      // explicitly clear any previously stored value so we don't keep showing the
      // underwriting AlertMessage from a stale store value.
      if (
        savedKey === 'premiumResponse' &&
        action?.params &&
        !Object.prototype.hasOwnProperty.call(action.params, 'referredTo')
      ) {
        try {
          const { referredToSource } = newState.allInitialWizardData || {};
          if (referredToSource !== 'client') {
            // Remove the key so conditional components treat it as unset.
            delete newState.allInitialWizardData.referredTo;
            delete newState.allInitialWizardData.referredToSource;
          }
        } catch (e) {
          // ignore
        }
      }

      // If premiumResponse request actually included referredTo (conditions true),
      // persist it into wizard state so UI conditionals (AlertMessage) can react.
      // We store from action.params because referredTo's param uses a staticValue
      // and typically has reducerKey=null.
      if (
        savedKey === 'premiumResponse' &&
        action?.params &&
        Object.prototype.hasOwnProperty.call(action.params, 'referredTo')
      ) {
        try {
          newState.allInitialWizardData.referredTo = action.params.referredTo;
          newState.allInitialWizardData.referredToSource = 'server';
        } catch (e) {
          // ignore
        }
      }

      // Ensure any apiCall params that specify a reducerKey are written into
      // the wizard store. Prefer values returned in the response (response.payload or response)
      // then fall back to the original params sent. This handles cases where
      // referredTo is sent as part of the request or returned by the API.
      try {
        const apiParams = action?.apiCall?.params || [];
        apiParams.forEach(p => {
          const paramKey = p?.key;
          const reducerKey = p?.reducerKey;
          if (!paramKey || !reducerKey) return;

          // Try to read from the API response first
          let value = null;
          // action.payload may be wrapped ({ responseType, payload }) or raw
          const resp = action?.payload || {};
          if (resp && resp.payload && Object.prototype.hasOwnProperty.call(resp.payload, paramKey)) {
            value = resp.payload[paramKey];
          } else if (Object.prototype.hasOwnProperty.call(resp, paramKey)) {
            value = resp[paramKey];
          } else if (action?.params && Object.prototype.hasOwnProperty.call(action.params, paramKey)) {
            // Only persist values that were actually included in the request payload.
            // This respects param-level conditions in the wizard JSON.
            value = action.params[paramKey];
          }

          if (value !== null && value !== undefined) {
            setRef(newState.allInitialWizardData, reducerKey, value);
          }
        });
      } catch (e) {
        // don't block reducer on this optional mapping
      }
      // console.log('allInitialWizardData111: ', newState?.allInitialWizardData);
      if (appendKeys && appendKeys.length > 0) {
        appendKeys.forEach(key => {
          // console.log('key: ', key);
          // console.log('newState: ', newState);
          // Guard: don't persist referredTo from the premium response if it wasn't
          // actually included in the request params (i.e., if its param-level
          // conditions evaluated false and it was omitted from the payload).
          // This keeps wizard state consistent with the payload rules.
          if (
            key?.key === 'referredTo' &&
            savedKey === 'premiumResponse' &&
            action?.params &&
            !Object.prototype.hasOwnProperty.call(action.params, 'referredTo')
          ) {
            return;
          }

          const tempValue =
            transformReducerValue(newState, key?.referenceKey) ||
            sourceTextFromData(newState, key?.staticValue);
          if (tempValue) {
            setRef(newState.allInitialWizardData, key?.key, tempValue);
          }
        });
        // console.log('allInitialWizardData22: ', newState?.allInitialWizardData);
      }

      // Build a UI-friendly array for premium response so wizards can consume it via store
      try {
        const premiumResp = newState?.allInitialWizardData?.premiumResponse;
        // premiumResp may be the API response wrapper ({ responseType, payload }) or the payload itself.
        const premiumRespData = premiumResp?.payload ?? premiumResp;
        console.log(premiumRespData, 'premiumRespData');
        // If payload is an array (e.g., [ { motorTT: [...] } ]) pick the first element.
        const normalizedResp = Array.isArray(premiumRespData) && premiumRespData.length > 0
          ? premiumRespData[0]
          : premiumRespData || {};
        console.log(normalizedResp, 'normalizedResp');
        if (normalizedResp) {
          const motorTT = Array.isArray(normalizedResp.motorTT) ? normalizedResp.motorTT : [];
          console.log(motorTT, 'motorTT');

          // Map plan codes to friendly display names
          const planTitleMap = {
            QGD: 'Queenguard',
            PGD: 'Primeguard',
            STD: 'Standard',
            HVV: 'High Value Vehicles',
            GMP: 'Guardian Master Plan',
            CLP: 'Loan to Road Campaign',
            EVP: 'Electric Guard'
          };

          const uiArr = [];
          const vehicleManufactureYear = toNumber(
            newState?.allInitialWizardData?.vehicleManufactureYear ||
            newState?.allInitialWizardData?.vehicleYear ||
            newState?.allInitialWizardData?.yearOfManufacture ||
            newState?.allInitialWizardData?.vehicleManufactureYear?.value,
          );
          const vehicleValue = toNumber(
            newState?.allInitialWizardData?.vehicleValue ||
            newState?.allInitialWizardData?.number_vehicleValue ||
            newState?.allInitialWizardData?.formatted_vehicleValue ||
            newState?.allInitialWizardData?.sumInsured ||
            newState?.allInitialWizardData?.marketValue,
          );
          const currentYear = new Date().getFullYear();
          const vehicleAge =
            vehicleManufactureYear !== null
              ? currentYear - vehicleManufactureYear
              : null;
          const dobAge = toNumber(newState?.allInitialWizardData?.dobAge);
          const isPrimeGuardAgeEligible =
            dobAge !== null && dobAge <= 65;
          const isPrimeGuardLegacyAgeEligible =
            dobAge !== null && dobAge >= 50 && dobAge <= 65;

          // Selected cover type from wizard dropdown (C/T/F)
          const selectedCoverageType = newState?.allInitialWizardData?.vehicleCoverageType;
          const coverTypeLabelFromSelection = coverageType => {
            const t = (coverageType || '').toString().trim().toUpperCase();
            if (t === 'T') return 'Third Party';
            if (t === 'F') return 'Third Party, Fire & Theft';
            // default to Comprehensive
            return 'Comprehensive';
          };
          const selectedCoverTypeLabel = coverTypeLabelFromSelection(selectedCoverageType);
          const tSel = (selectedCoverageType || '').toString().trim().toUpperCase();
          const isThirdPartySelection = tSel === 'T' || tSel === 'F';
          const isThirdPartyOnlySelection = tSel === 'T';
          const isFireAndTheftSelection = tSel === 'F';
          const isPickupBodyType =
            (newState?.allInitialWizardData?.vehicleBodyType || '')
              .toString()
              .trim()
              .toLowerCase() === 'pickup';
          const fuelType =
            (newState?.allInitialWizardData?.vehicleFuelType || '')
              .toString()
              .trim()
              .toLowerCase();
          const isPrimeGuardFuelEligible =
            ['electric', 'hybrid', 'diesel', 'gas'].includes(fuelType);
          const isPrimeGuardVehicleAgeEligible =
            vehicleAge !== null && vehicleAge <= 20;
          const isPrimeGuardLegacyEligible =
            vehicleAge !== null &&
            vehicleAge <= 10 &&
            vehicleValue !== null &&
            vehicleValue >= 100000 &&
            isPrimeGuardLegacyAgeEligible;
          const isPrimeGuardEligible =
            isPrimeGuardLegacyEligible ||
            (isThirdPartyOnlySelection &&
              isPrimeGuardVehicleAgeEligible &&
              isPrimeGuardAgeEligible &&
              isPrimeGuardFuelEligible);
          motorTT.forEach(group => {
            if (!group || typeof group !== 'object') return;
            Object.keys(group).forEach(planKey => {
              const plan = group[planKey];
              if (!plan || typeof plan !== 'object') return;
              if (planKey === 'PGD' && !isPrimeGuardEligible) return;

              const price = plan.priceXcg ?? null;

              // try to extract premium/admin/tax from result or premium arrays
              let premium = null;
              let admin = null;
              let tax = null;

              const scanArray = arr => {
                if (!Array.isArray(arr)) return;
                arr.forEach(entry => {
                  const t = (entry?.type || '').toLowerCase();
                  const p = entry?.pricing?.premiumXcg ?? entry?.priceXcg ?? null;
                  if (!p && entry?.pricing && entry?.pricing?.premiumXcg === 0) {
                    // keep 0
                  }
                  if (t.includes('insurance') || t.includes('premium')) {
                    if (premium == null) premium = p;
                  } else if (t.includes('administration')) {
                    if (admin == null) admin = p;
                  } else if (t.includes('tax')) {
                    if (tax == null) tax = p;
                  }
                });
              };

              scanArray(plan.result);
              scanArray(plan.premium);

              // fallback: try to read common keys
              if (premium == null && plan.premiumTotal) premium = plan.premiumTotal;

              const currency = normalizedResp?.currency || 'TTD';
              const formatNumber = v => (v === null || v === undefined ? null : Number(v));


              const coverageMatrix = {
                features: [
                  {
                    key: 'coverType',
                    title: 'Cover Type',
                    values: {
                      QGD: 'Comprehensive',
                      HVV: 'Comprehensive',
                      GMP: 'Comprehensive',
                      CLP: 'Comprehensive',
                      EVP: 'Comprehensive',
                      PGD: isThirdPartySelection ? selectedCoverTypeLabel : 'Comprehensive',
                      STD: isThirdPartySelection ? selectedCoverTypeLabel : 'Comprehensive',
                    },
                  },
                  { key: 'tpbpd', title: 'Third-Party Liability Coverage (Bodily Injury & Property Damage)', values: { QGD: true, HVV: true, GMP: true, CLP: true, EVP: true, PGD: true, STD: true } },
                  { key: 'clothing', title: 'Clothing & Personal Effects', values: { QGD: true, HVV: true, GMP: true, CLP: true, EVP: true, PGD: isThirdPartySelection ? null : true, STD: isThirdPartySelection ? null : true } },
                  { key: 'legal', title: 'Legal Charges (Manslaughter)', values: { QGD: true, HVV: true, GMP: true, CLP: true, EVP: true, PGD: isThirdPartyOnlySelection || (isThirdPartySelection ? null : true), STD: true } },
                  { key: 'emergency', title: 'Emergency Treatment', values: { QGD: true, HVV: true, GMP: true, CLP: true, EVP: true, PGD: isThirdPartyOnlySelection || (isThirdPartySelection ? null : true), STD: true } },
                  { key: 'childseat', title: 'Child Car Seat Benefit', values: { QGD: true, HVV: true, GMP: true, CLP: true, EVP: true, PGD: isThirdPartySelection ? null : true, STD: isThirdPartySelection ? null : true } },
                  { key: 'replacementkeys', title: 'Replacement Keys', values: { QGD: true, HVV: true, GMP: true, CLP: true, EVP: true, PGD: isThirdPartySelection ? null : true, STD: isThirdPartySelection ? null : true } },
                  { key: 'medical', title: 'Medical Expenses', values: { QGD: true, HVV: true, GMP: true, CLP: true, EVP: true, PGD: isThirdPartySelection ? null : true, STD: isThirdPartySelection ? null : true } },
                  { key: 'personalacc', title: 'Personal Accident Benefit', values: { QGD: true, HVV: true, GMP: true, CLP: true, EVP: true, PGD: isThirdPartySelection ? null : true, STD: null } },
                  { key: 'specialperils', title: 'Special Perils', values: { QGD: true, HVV: true, GMP: true, CLP: true, EVP: true, PGD: isThirdPartySelection ? null : true, STD: isThirdPartySelection ? null : true } },
                  { key: 'antitheft', title: 'Anti Theft Discount', values: { QGD: true, HVV: true, GMP: true, CLP: true, EVP: true, PGD: isThirdPartySelection ? null : true, STD: isThirdPartySelection ? null : true } },
                  { key: 'specialdiscount', title: 'Special Discount', values: { QGD: true, HVV: true, GMP: true, CLP: true, EVP: true, PGD: isThirdPartyOnlySelection || (isThirdPartySelection ? null : true), STD: true } },
                  { key: 'windscreen', title: 'Windscreen Cover (All Glass)', values: { QGD: 5000, HVV: 7500, GMP: 2500, CLP: 5000, EVP: 2500, PGD: isThirdPartySelection ? null : 5000, STD: isThirdPartySelection ? null : 2500 } },
                  { key: 'courtesycar', title: 'Courtesy Car/Loss Of Use', values: { QGD: isPickupBodyType ? null : true, HVV: isPickupBodyType ? null : true, GMP: isPickupBodyType ? null : true, CLP: isPickupBodyType ? null : true, EVP: isPickupBodyType ? null : true, PGD: isPickupBodyType ? null : (isThirdPartySelection ? null : true), STD: isPickupBodyType ? null : (isThirdPartySelection ? null : true) } },
                  { key: 'agreeddep', title: 'Agreed Depreciation', values: { QGD: true }, },
                  { key: 'motorassist', title: 'Motor Assist (Road Side Assistance)', values: { QGD: true, HVV: true, GMP: true, CLP: true, EVP: true, PGD: isThirdPartySelection ? null : true, STD: isThirdPartySelection ? null : true } },
                  { key: 'survivorbenefit', title: 'Survivor Benefit', values: { PGD: isThirdPartySelection ? null : true } }
                ],
                primaryHeading: "What's Covered"
              };

              const formatCurrencyValue = (v, currency) => {
                if (v === null || v === undefined) return null;
                try {
                  const n = Number(v);
                  // Use toLocaleString for thousands separators where available
                  const formatted = Number.isFinite(n) ? n.toLocaleString(undefined) : String(v);
                  return `${currency} ${formatted}`;
                } catch (e) {
                  return `${currency} ${v}`;
                }
              };

              // Build whatsCovered shaped like the UI expects for a given plan key
              const buildWhatsCoveredForPlan = (planKey, currency = '') => {
                const items = coverageMatrix.features
                  .filter(
                    f =>
                      !(
                        isThirdPartyOnlySelection &&
                        (f.key === 'clothing' ||
                          f.key === 'childseat' ||
                          f.key === 'antitheft' ||
                          f.key === 'agreeddep')
                      )
                  )
                  .map(f => {
                    const hasKey = f.values && Object.prototype.hasOwnProperty.call(f.values, planKey);
                    const v = hasKey ? f.values[planKey] : null;

                    // Present: show a check icon
                    // render a plain check mark (Material Icons ligature 'check') so it appears
                    // as the small purple tick in the comparison table
                    if (v === true) return { title: f.title, startIcon: 'check' };

                    // Numeric amounts: format as currency (e.g. windscreens)
                    if (typeof v === 'number') return { title: f.title, secondaryTitle: formatCurrencyValue(v, currency), startIcon: null };
                    if (typeof v === 'string') return { title: f.title, secondaryTitle: v, startIcon: null };

                    // Explicitly show a dash for not-available or unspecified values to match the spreadsheet
                    return { title: f.title, secondaryTitle: '-', startIcon: null };
                  });

                return {
                  items,
                  primaryHeading: coverageMatrix.primaryHeading,
                };
              };

              const sampleData = {
                breakdown: {
                  items: [
                    {
                      title: 'Premium',
                      secondaryTitle: formatNumber(premium),
                      secondaryUnits: currency,
                      secondaryTitleIsCurrency: true,
                      secondaryTitleIsNumeric: true,
                    },
                    {
                      title: 'Government Insurance Tax',
                      secondaryTitle: formatNumber(tax),
                      secondaryUnits: currency,
                      secondaryTitleIsCurrency: true,
                      secondaryTitleIsNumeric: true,
                    },
                    // {
                    //   title: 'Total Premium',
                    //   secondaryTitle: formatNumber(price),
                    //   secondaryUnits: currency,
                    //   secondaryTitleIsCurrency: true,
                    //   secondaryTitleIsNumeric: true,
                    // },
                  ],
                  primaryHeading: 'Breakdown',
                  secondaryHeading: currency,
                },
                whatsCovered: buildWhatsCoveredForPlan(planKey, currency),
              };

              uiArr.push({
                title: planTitleMap[planKey] || plan.title || planKey,
                secondaryTitle: formatNumber(price != null ? price : null),
                secondaryTitleIsCurrency: true,
                secondaryTitleIsNumeric: true,
                secondaryUnits: currency,
                value: planKey,
                sampleData,
                hidden: false,
              });
            });
          });

          newState.allInitialWizardData.premiumResponseForUI = uiArr;
          console.log('premiumResponseForUI set to:', uiArr);

          if (!isPrimeGuardEligible && newState?.allInitialWizardData?.coverType === 'PGD') {
            newState.allInitialWizardData.coverType = '';
            newState.allInitialWizardData.selectedPremiumListItems = [];
            newState.allInitialWizardData.thirdPartyLiability = null;
            newState.allInitialWizardData.selectedPremiumRaw = null;
          }

          const preserveCoverageSelection =
            action?.apiCall?.preserveCoverageSelection === true ||
            (action?.apiCall?.preserveCoverageSelection !== false &&
              !!newState?.allInitialWizardData?.coverType);
          if (!preserveCoverageSelection) {
            // Don't auto-select a plan. Keep the premium breakdown empty until the user
            // explicitly chooses a coverage plan.
            newState.allInitialWizardData.selectedPremiumListItems = [];
            newState.allInitialWizardData.thirdPartyLiability = null;
            // Also clear any previously selected plan from persisted wizard state.
            // Without this, redux-persist may rehydrate an old `coverType` (e.g. QGD)
            // and the UI will appear selected even though the user hasn't picked a plan
            // for the newly fetched premium response.
            newState.allInitialWizardData.coverType = '';
            newState.allInitialWizardData.selectedPremiumRaw = null;
          } else {
            const existingCoverType = newState.allInitialWizardData.coverType;
            if (existingCoverType && Array.isArray(uiArr) && uiArr.length > 0) {
              const selectedUI = uiArr.find(i => i?.value === existingCoverType) || null;
              if (selectedUI) {
                const breakdownItems = selectedUI?.sampleData?.breakdown?.items || [];
                const summaryItem = {
                  title: 'Total Premium',
                  secondaryTitle: selectedUI?.secondaryTitle,
                  secondaryUnits: selectedUI?.secondaryUnits || null,
                  secondaryTitleIsCurrency: !!selectedUI?.secondaryTitleIsCurrency,
                  secondaryTitleIsNumeric: !!selectedUI?.secondaryTitleIsNumeric,
                };
                newState.allInitialWizardData.selectedPremiumListItems = [
                  ...breakdownItems,
                  summaryItem,
                ];
                newState.allInitialWizardData.thirdPartyLiability = 'Included';

                // Keep selectedPremiumRaw aligned with the latest response.
                let foundRaw = null;
                if (Array.isArray(motorTT)) {
                  motorTT.forEach(group => {
                    Object.keys(group || {}).forEach(key => {
                      const plan = group[key];
                      if (plan && key === existingCoverType) {
                        foundRaw = plan;
                      }
                    });
                  });
                }
                if (foundRaw) {
                  newState.allInitialWizardData.selectedPremiumRaw = foundRaw;
                }
              }
            }
          }
        }
      } catch (e) {
        // don't block reducer on transform errors
        console.warn('premiumResponseForUI transform error', e);
      }
      const derivedWizardData = applyDerivedReferredTo(newState.allInitialWizardData);
      if (derivedWizardData !== newState.allInitialWizardData) {
        newState.allInitialWizardData = derivedWizardData;
        newState.allWizardData = {
          ...newState.allWizardData,
          [userId]: derivedWizardData,
        };
      }

      return newState;
    }
    case API_CALL_WIZARD_API_ERROR: {
      let error = action?.payload;

      const httpMethod = action?.apiCall?.httpMethod;

      if (
        httpMethod === 'strapiPost' ||
        httpMethod === 'strapiGet' ||
        !error.responseType
      ) {
        error = { responseType: 'error', payload: error };
      }

      // // console.log('error: ', error);
      const savedKey = action?.savedKey;
      // // console.log('savedKey: ', savedKey);
      const initialPendingStatuses = state?.isApiCallWizardPending
        ? state?.isApiCallWizardPending
        : {};
      const initialErrorStatuses = state?.isApiCallWizardError
        ? state?.isApiCallWizardError
        : {};
      const initialSuccessStatuses = state?.isApiCallWizardSuccess
        ? state?.isApiCallWizardSuccess
        : {};

      const initialError = state?.apiCallWizardError ? state?.apiCallWizardError : {};
      const newError = { ...initialError, [savedKey]: error };
      const initialResponse = state?.apiCallWizardResponse;
      const newResponse = { ...initialResponse, [savedKey]: error };
      // // console.log('newResponse: ', newResponse);
      const newPendingStatuses = { ...initialPendingStatuses, [savedKey]: false };
      // // console.log('newPendingStatuses: ', newPendingStatuses);
      const newSuccessStatuses = { ...initialSuccessStatuses, [savedKey]: false };
      // // console.log('newSuccessStatuses: ', newSuccessStatuses);
      const newErrorStatuses = { ...initialErrorStatuses, [savedKey]: true };
      // console.log('newErrorStatuses: ', newErrorStatuses);

      return {
        ...state,
        isApiCallWizardPending: newPendingStatuses,
        isApiCallWizardError: newErrorStatuses,
        isApiCallWizardSuccess: newSuccessStatuses,
        apiCallWizardError: newError,
        apiCallWizardResponse: newResponse,
      };
    }

    case DUTCH_API_CALL_WIZARD_API_SUCCESS: {
      const userId = state?.allInitialWizardData?.auth?.userId || 'none';
      const allInitialWizardData = {
        ...state?.allInitialWizardData,
        [action.savedKey]: action.payload,
      };
      const nextWizardData = applyDerivedReferredTo(allInitialWizardData);
      const allWizardData = {
        ...state.allWizardData,
        [userId]: nextWizardData,
      };

      const newState = {
        ...state,
        allWizardData,
        allInitialWizardData: nextWizardData,
      };
      return newState;
    }

    case DUTCH_API_CALL_WIZARD_API_ERROR: {
      const userId = state?.allInitialWizardData?.auth?.userId || 'none';
      const allInitialWizardData = {
        ...state?.allInitialWizardData,
        [action.savedKey]: action.payload,
      };
      const nextWizardData = applyDerivedReferredTo(allInitialWizardData);
      const allWizardData = {
        ...state.allWizardData,
        [userId]: nextWizardData,
      };

      const newState = {
        ...state,
        allWizardData,
        allInitialWizardData: nextWizardData,
      };
      return newState;
    }

    case ADD_LOCAL_WIZARD_SUCCESS: {
      const wizard = action?.payload || null;

      // const wizardData = { ...response };
      // const allWizardData = { ...state.allWizardData, ...response };

      return {
        ...state,
        isApiCallWizardPending: false,
        isApiCallWizardError: false,
        isApiCallWizardSuccess: false,
        isSearchCallWizardPending: false,
        isSearchCallWizardError: false,
        isSearchCallWizardSuccess: false,
        isGettingWizardSuccess: true,
        // apiCallWizardResponse: initialState.apiCallWizardResponse,
        wizard,
        // resettedWizardData: false,
      };
    }

    case ADD_LOCAL_MODAL_WIZARD_SUCCESS: {
      const modalWizard = action?.payload || null;
      // const wizardData = { ...response };
      // const allWizardData = { ...state.allWizardData, ...response };

      return {
        ...state,
        // isApiCallWizardPending: false,
        // isApiCallWizardError: false,
        // isApiCallWizardSuccess: false,
        // isSearchCallWizardPending: false,
        // isSearchCallWizardError: false,
        // isSearchCallWizardSuccess: false,
        modalWizard,
        // resettedWizardData: false,
      };
    }

    case ADD_INITIAL_WIZARD_DATA_SUCCESS: {
      const response = action.payload || {};
      // console.log('response: ', response);
      const userId = state?.allInitialWizardData?.auth?.userId || 'none';
      const dataSettings = action?.dataSettings || null;
      const { focusKey } = action.payload;
      const initialWizardData = { ...response };
      // console.log('initialWizardData: ', initialWizardData);
      const nowTime = new Date().getTime();
      const initialAllWizardData = { ...state.allInitialWizardData };
      let finalAllInitialWizardData = {};

      if (dataSettings?.isSharedObject) {
        finalAllInitialWizardData = mergeDeep(initialAllWizardData, initialWizardData, {
          [persistKey]: nowTime,
        });
      } else {
        finalAllInitialWizardData = {
          ...initialAllWizardData,
          ...initialWizardData,
          [persistKey]: nowTime,
        };
      }

      if (dataSettings?.appendKeys) {
        for (let i = 0; i < dataSettings?.appendKeys.length; i++) {
          const appendKey = dataSettings?.appendKeys[i];
          // console.log('appendKey: ', appendKey);
          const { show: subShow } = checkComponent(
            appendKey,
            finalAllInitialWizardData,
            null,
            null,
          );
          // console.log('subShow: ', subShow);

          const reducerKeyData = getRef(
            finalAllInitialWizardData,
            appendKey.referenceKey,
          );
          const staticValueData = sourceTextFromData(
            finalAllInitialWizardData,
            appendKey.staticValue,
          );
          const newReducerKeyValue = transformConditionalValue(
            reducerKeyData,
            appendKey.fieldType,
          );
          const newStaticValue = transformConditionalValue(
            staticValueData,
            appendKey.fieldType,
          );
          if (subShow) {
            setRef(
              finalAllInitialWizardData,
              appendKey?.key,
              newReducerKeyValue || newStaticValue,
            );
          } else {
            setRef(finalAllInitialWizardData, appendKey?.key, newStaticValue);
          }
        }
      }

      const sameAsHomeRaw = finalAllInitialWizardData?.sameAsHomeAddress;
      const isSameAsHome = Array.isArray(sameAsHomeRaw)
        ? sameAsHomeRaw.some(item => item?.value === 'yes' || item === 'yes')
        : sameAsHomeRaw === true || sameAsHomeRaw === 'yes';
      if (isSameAsHome) {
        const homeAreaValue = finalAllInitialWizardData?.homeAddressArea;
        const homeStreetValue = finalAllInitialWizardData?.homeStreetAddress;
        if (homeAreaValue !== undefined && homeAreaValue !== null) {
          setRef(finalAllInitialWizardData, 'vehicleHousedArea', homeAreaValue);
        }
        if (homeStreetValue !== undefined && homeStreetValue !== null) {
          setRef(
            finalAllInitialWizardData,
            'vehicleHousedStreetAddress',
            homeStreetValue,
          );
        }
      }

      // When "Different Mailing Address" is NOT checked, copy home address
      // fields into the mailing address fields so the backend receives both.
      // When it IS checked, clear the mailing fields so the user starts fresh.
      const mailingSameRaw = finalAllInitialWizardData?.mailingSameAsHome;
      const isDifferentMailingChecked = Array.isArray(mailingSameRaw)
        ? mailingSameRaw.some(item => item?.value === 'no' || item === 'no')
        : mailingSameRaw === 'no';
      if (!isDifferentMailingChecked) {
        const homeAreaVal = finalAllInitialWizardData?.homeAddressArea;
        const homeStreetVal = finalAllInitialWizardData?.homeStreetAddress;
        if (homeAreaVal !== undefined && homeAreaVal !== null) {
          setRef(finalAllInitialWizardData, 'mailingAddressArea', homeAreaVal);
        }
        if (homeStreetVal !== undefined && homeStreetVal !== null) {
          setRef(
            finalAllInitialWizardData,
            'mailingStreetAddress',
            homeStreetVal,
          );
        }
      } else if (focusKey === 'mailingSameAsHome') {
        // User just checked "Different Mailing Address" – clear the copied values
        // so the mailing fields appear empty for the user to fill in.
        setRef(finalAllInitialWizardData, 'mailingAddressArea', null);
        setRef(finalAllInitialWizardData, 'mailingStreetAddress', null);
      }

      const allWizardData = {
        ...state.allWizardData,
        [userId]: finalAllInitialWizardData,
      };

      // If a coverage plan was selected (e.g., coverType), build a store-friendly
      // list for the premium breakdown DisplayListItems to consume.
      try {
        const coverType = finalAllInitialWizardData?.coverType || state?.allInitialWizardData?.coverType;
        const uiArr =
          state?.allInitialWizardData?.premiumResponseForUI ||
          finalAllInitialWizardData?.premiumResponseForUI ||
          [];

        if (coverType && Array.isArray(uiArr) && uiArr.length > 0) {
          const selectedUI = uiArr.find(i => i?.value === coverType) || null;
          if (selectedUI) {
            const breakdownItems = selectedUI?.sampleData?.breakdown?.items || [];
            const summaryItem = {
              title: 'Total Premium',
              secondaryTitle: selectedUI?.secondaryTitle,
              secondaryUnits: selectedUI?.secondaryUnits || null,
              secondaryTitleIsCurrency: !!selectedUI?.secondaryTitleIsCurrency,
              secondaryTitleIsNumeric: !!selectedUI?.secondaryTitleIsNumeric,
            };

            // store as an array that DisplayListItems can consume (breakdown items first, summary last)
            finalAllInitialWizardData.selectedPremiumListItems = [...breakdownItems, summaryItem];
            finalAllInitialWizardData.thirdPartyLiability = 'Included';

            // Also store the raw selected plan (if available) for other components to use
            const rawResp = state?.allInitialWizardData?.premiumResponse || finalAllInitialWizardData?.premiumResponse;
            if (rawResp) {
              // normalize and search for motorTT plan matching value
              const norm = rawResp?.payload || rawResp;
              const candidate = Array.isArray(norm) ? norm[0] : norm;
              const motorGroups = candidate?.motorTT || candidate?.motorTT || [];
              let foundRaw = null;
              if (Array.isArray(motorGroups)) {
                motorGroups.forEach(group => {
                  Object.keys(group || {}).forEach(key => {
                    const plan = group[key];
                    if (plan && key === coverType) {
                      foundRaw = plan;
                    }
                  });
                });
              }
              if (foundRaw) {
                finalAllInitialWizardData.selectedPremiumRaw = foundRaw;
              }
            }
          }
        }
      } catch (e) {
        // don't block the reducer on this auxiliary transform
      }

      if (focusKey === 'sourceSecurity') {
        finalAllInitialWizardData.selectedSourceSecurity = finalAllInitialWizardData?.sourceAccountPayload?.holdings?.find(
          x => x?.secCode === action?.payload?.sourceSecurity,
        );
      }

      const derivedWizardData = applyDerivedReferredTo(finalAllInitialWizardData);
      if (derivedWizardData !== finalAllInitialWizardData) {
        finalAllInitialWizardData = derivedWizardData;
        allWizardData[userId] = derivedWizardData;
      }
      // console.log('allInitialWizardData: ', allInitialWizardData);
      return {
        ...state,
        initialWizardData,
        allInitialWizardData: finalAllInitialWizardData,
        allWizardData,
        focusKey,
        isGettingWizardPending: false,
        isGettingWizardError: false,
        isGettingWizardSuccess: false,
        resettedWizardData: false,
        previousWizardData: state.allInitialWizardData,

        // isLoadingWizard: true,
      };
    }

    case EMPTY_INITIAL_WIZARD_DATA_SUCCESS: {
      const response = action.payload || {};
      const userId = state?.allInitialWizardData?.auth?.userId || 'none';
      const { focusKey } = action.payload;
      const initialWizardData = { ...response };
      const nowTime = new Date().getTime();
      let allInitialWizardData = {
        ...response,
        [persistKey]: nowTime,
      };
      allInitialWizardData = applyDerivedReferredTo(allInitialWizardData);

      const allWizardData = {
        ...state.allWizardData,
        [userId]: allInitialWizardData,
      };

      return {
        ...state,
        initialWizardData,
        allInitialWizardData,
        allWizardData,
        focusKey,
        isGettingWizardPending: false,
        isGettingWizardError: false,
        isGettingWizardSuccess: false,
        resettedWizardData: false,

        // isLoadingWizard: true,
      };
    }

    /* case LOADING_WIZARD_SUCCESS: {
      const response = action.payload || false;

      return {
        ...state,
        isLoadingWizard: response,
      };
    } */

    case ADD_LAST_ENTRY_POINT_SUCCESS: {
      const lastEntryPoint = action?.payload;
      return {
        ...state,
        lastEntryPoint,
      };
    }

    case RESET_WIZARD_DATA_SUCCESS: {
      const userId = state?.allInitialWizardData?.auth?.userId || 'none';
      const clearResponse = action?.clearResponse || false;
      const modalWizardSlug = clearResponse ? null : state.modalWizardSlug;
      const wizardData = {};
      let newInitialData = { ...state.allInitialWizardData, ...action?.payload };
      newInitialData = applyDerivedReferredTo(newInitialData);
      const nextBackButtonLink = action?.params?.nextBackButtonLink || null;
      // const onLoadApiCalls = action?.onLoadApiCalls || [];

      // console.log('state.allInitialWizardData: ', state.allInitialWizardData);

      const allWizardData = {
        ...state.allWizardData,
        [userId]: newInitialData,
      };

      const newApiResponse = clearResponse
        ? initialState.apiCallWizardResponse
        : state.apiCallWizardResponse;

      return {
        ...state,
        apiCallWizardResponse: newApiResponse, // s initialState.apiCallWizardResponse,
        lastAllInitialWizardData: state.allInitialWizardData,
        isApiCallWizardPending: initialState.isApiCallWizardPending,
        isApiCallWizardError: initialState.isApiCallWizardError,
        isApiCallWizardSuccess: initialState.isApiCallWizardSuccess,
        apiCallWizardError: initialState.apiCallWizardError,
        allInitialWizardData: newInitialData,
        allWizardData,
        resettedWizardData: true,
        nextBackButtonLink,
        lastEntryPoint: state.lastEntryPoint,
        modalWizardSlug,
      };
    }

    case SELECT_CLIENTS_SUCCESS: {
      const userId = state?.allInitialWizardData?.auth?.userId || 'none';
      const newInitialData = applyDerivedReferredTo({
        ...initialState.allInitialWizardData,
      });

      const allWizardData = {
        ...state.allWizardData,
        [userId]: newInitialData,
      };
      return {
        ...state,
        // apiCallWizardResponse: initialState.apiCallWizardResponse,
        isApiCallWizardPending: initialState.isApiCallWizardPending,
        isApiCallWizardError: initialState.isApiCallWizardError,
        isApiCallWizardSuccess: initialState.isApiCallWizardSuccess,
        apiCallWizardError: initialState.apiCallWizardError,
        allInitialWizardData: newInitialData,
        allWizardData,
        resettedWizardData: true,
        lastEntryPoint: state.lastEntryPoint,
      };
    }

    case RESET_WIZARD_SUCCESS: {
      return {
        ...initialState,
        // apiCallWizardError: state.apiCallWizardError,
        apiCallWizardResponse: state.apiCallWizardResponse,
        initialWizardData: state.initialWizardData,
        allInitialWizardData: state.allInitialWizardData,
        wizard: state.wizard,
        resettedWizardData: state.resettedWizardData,
        nextBackButtonLink: state.nextBackButtonLink,
        sentEmail: state.sentEmail,
        lastEntryPoint: state.lastEntryPoint,
      };
    }

    case RESET_WIZARD_FIELDS_ONCHANGE: {
      const { resetFields } = action.payload;
      const { allInitialWizardData } = state;
      const userId = allInitialWizardData?.auth?.userId || 'none';
      let updatedAllInitialWizardData = { ...allInitialWizardData };
      if (Array.isArray(resetFields) && resetFields.length > 0) {
        resetFields?.forEach(obj => {
          updatedAllInitialWizardData[obj.name] = obj.staticValue;
        });
      }
      updatedAllInitialWizardData = applyDerivedReferredTo(updatedAllInitialWizardData);
      const allWizardData = {
        ...state.allWizardData,
        [userId]: updatedAllInitialWizardData,
      };
      return {
        ...state,
        allInitialWizardData: updatedAllInitialWizardData,
        allWizardData,
        resetOnChange: true,
      };
    }

    case GET_WIZARD_API_REQUEST:
      return {
        ...state,
        isApiCallWizardPending: false,
        isApiCallWizardError: false,
        isApiCallWizardSuccess: false,
        isSearchCallWizardPending: false,
        isSearchCallWizardError: false,
        isSearchCallWizardSuccess: false,
        isGettingWizardPending: true,
        isGettingWizardError: false,
        isGettingWizardSuccess: false,
      };
    case GET_WIZARD_API_SUCCESS: {
      const wizard =
        !!action?.payload && action.payload.length > 0 ? action.payload[0] : null;
      // const quotes = response?.payload || [];
      const response = action?.payload;
      response.payload = null;
      return {
        ...state,
        isGettingWizardPending: false,
        isGettingWizardError: false,
        isGettingWizardSuccess: true,
        getWizardResponse: response, // action.payload, // newProducts,
        // apiCallWizardResponse: initialState.apiCallWizardResponse,
        wizard,
        // resettedWizardData: false,
      };
    }
    case GET_WIZARD_API_ERROR:
      return {
        ...state,
        isGettingWizardPending: false,
        isGettingWizardError: true,
        isGettingWizardSuccess: false,
        // getWizardError: action.payload,
      };

    case GET_MODAL_WIZARD_API_REQUEST:
      return {
        ...state,
        // isApiCallWizardPending: false,
        // isApiCallWizardError: false,
        // isApiCallWizardSuccess: false,
        // isSearchCallWizardPending: false,
        // isSearchCallWizardError: false,
        // isSearchCallWizardSuccess: false,
        isGettingModalWizardPending: true,
        isGettingModalWizardError: false,
        isGettingModalWizardSuccess: false,
      };
    case GET_MODAL_WIZARD_API_SUCCESS: {
      const modalWizard =
        !!action?.payload && action.payload.length > 0 ? action.payload[0] : null;
      // const quotes = response?.payload || [];
      const response = action?.payload;
      response.payload = null;
      return {
        ...state,
        isGettingModalWizardPending: false,
        isGettingModalWizardError: false,
        isGettingModalWizardSuccess: true,
        getModalWizardResponse: response, // action.payload, // newProducts,
        modalWizard,
        // resettedWizardData: false,
      };
    }
    case GET_MODAL_WIZARD_API_ERROR:
      return {
        ...state,
        isGettingModalWizardPending: false,
        isGettingModalWizardError: true,
        isGettingModalWizardSuccess: false,
        // getWizardError: action.payload,
      };

    case SEARCH_CALL_WIZARD_API_REQUEST: {
      const savedKey = action?.savedKey;

      const initialPendingStatuses = state?.isSearchCallWizardPending
        ? state?.isSearchCallWizardPending
        : {};
      const initialErrorStatuses = state?.isSearchCallWizardError
        ? state?.isSearchCallWizardError
        : {};
      const initialSuccessStatuses = state?.isSearchCallWizardSuccess
        ? state?.isSearchCallWizardSuccess
        : {};

      const newPendingStatuses = {
        ...initialPendingStatuses,
        [savedKey]: true,
      };
      const newSuccessStatuses = { ...initialErrorStatuses, [savedKey]: false };
      const newErrorStatuses = { ...initialSuccessStatuses, [savedKey]: false };
      return {
        ...state,
        isSearchCallWizardPending: newPendingStatuses,
        isSearchCallWizardError: newErrorStatuses,
        isSearchCallWizardSuccess: newSuccessStatuses,
      };
    }
    case SEARCH_CALL_WIZARD_API_SUCCESS: {
      const response = action?.payload;
      const savedKey = action?.savedKey;

      const initialResponse = state?.searchCallWizardResponse
        ? state?.searchCallWizardResponse
        : {};
      const initialPendingStatuses = state?.isSearchCallWizardPending
        ? state?.isSearchCallWizardPending
        : {};
      const initialErrorStatuses = state?.isSearchCallWizardError
        ? state?.isSearchCallWizardError
        : {};
      const initialSuccessStatuses = state?.isSearchCallWizardSuccess
        ? state?.isSearchCallWizardSuccess
        : {};

      const initialApiCallWizardResponse = state?.apiCallWizardResponse;
      const apiResponse = { ...initialApiCallWizardResponse, [savedKey]: response };

      const newResponse = { ...initialResponse, [savedKey]: response };

      const newPendingStatuses = { ...initialPendingStatuses, [savedKey]: false };
      const newSuccessStatuses = { ...initialErrorStatuses, [savedKey]: true };
      const newErrorStatuses = { ...initialSuccessStatuses, [savedKey]: false };

      return {
        ...state,
        isSearchCallWizardPending: newPendingStatuses,
        isSearchCallWizardError: newErrorStatuses,
        isSearchCallWizardSuccess: newSuccessStatuses,
        searchCallWizardResponse: newResponse, // newProducts,
        apiCallWizardResponse: apiResponse,
      };
    }
    case SEARCH_CALL_WIZARD_API_ERROR: {
      const error = action?.payload;
      const savedKey = action?.savedKey;
      const initialPendingStatuses = state?.isSearchCallWizardPending
        ? state?.isSearchCallWizardPending
        : {};
      const initialErrorStatuses = state?.isSearchCallWizardError
        ? state?.isSearchCallWizardError
        : {};
      const initialSuccessStatuses = state?.isSearchCallWizardSuccess
        ? state?.isSearchCallWizardSuccess
        : {};

      const initialError = state?.searchCallWizardError
        ? state?.searchCallWizardError
        : {};
      const newError = { ...initialError, [savedKey]: error };
      const newPendingStatuses = { ...initialPendingStatuses, [savedKey]: false };
      const newSuccessStatuses = { ...initialErrorStatuses, [savedKey]: false };
      const newErrorStatuses = { ...initialSuccessStatuses, [savedKey]: true };

      return {
        ...state,
        isSearchCallWizardPending: newPendingStatuses,
        isSearchCallWizardError: newErrorStatuses,
        isSearchCallWizardSuccess: newSuccessStatuses,
        // searchCallWizardError: newError,
      };
    }

    case RESET_WIZARD_FLAG_SUCCESS:
      return {
        ...state,
        resettedWizardData: action.payload,
      };

    case SET_API_CALL_PENDING: {
      return {
        ...state,
        isApiCallWizardPending: action?.payload,
        isApiCallWizardSuccess: false,
        isApiCallWizardError: false,
      };
    }

    case SET_MODAL_API_CALL_PENDING: {
      return {
        ...state,
        isModalApiCallWizardPending: action.payload,
      };
    }
    case ADD_MODAL_WIZARD_SLUG_SUCCESS: {
      return {
        ...state,
        modalWizardSlug: action.payload,
      };
    }

    case RESET_MODAL_WIZARD_SLUG_SUCCESS: {
      return {
        ...state,
        modalWizardSlug: null,
      };
    }

    case SET_CHECKBOX_STATE: {
      const { flag } = action.payload;
      return {
        ...state,
        estimateQuoteCheckboxState: flag,
      };
    }
    default:
      return state;
  }
}
export default wizardReducer;

/*
      if (
        focusKey === 'sourceSecurity' ||
        focusKey === 'sourceAccount' ||
        focusKey === 'destinationAccount' ||
        focusKey === 'destinationSecurity'
      ) {
        const accounts = state?.apiCallWizardResponse?.accounts?.payload;
        const sourceAccount = allInitialWizardData?.sourceAccount;
        if (sourceAccount && accounts && accounts.length > 0) {
          const sourceAccountPayload = accounts?.find(x2 => x2.id === sourceAccount);
          allInitialWizardData.sourceAccountPayload = sourceAccountPayload;
          const sourceSecurity = allInitialWizardData?.sourceSecurity;
          if (sourceSecurity && sourceAccountPayload) {
            allInitialWizardData.sourceSecurityPayload = sourceAccountPayload?.holdings?.find(
              x2 => x2.secCode === sourceSecurity,
            );
          }
        }

        const destinationAccount = allInitialWizardData?.destinationAccount;
        if (destinationAccount && accounts && accounts.length > 0) {
          const destinationAccountPayload = accounts?.find(
            x2 => x2.id === destinationAccount,
          );
          allInitialWizardData.destinationAccountPayload = destinationAccountPayload;
          const destinationSecurity = allInitialWizardData?.destinationSecurity;
          if (destinationSecurity && destinationAccountPayload) {
            allInitialWizardData.destinationSecurityPayload = destinationAccountPayload?.holdings?.find(
              x2 => x2.secCode === destinationSecurity,
            );
          }
        }
      }
      */

/*

    case ADD_WIZARD_DATA_SUCCESS: {
      const response = action.payload || {};
      const wizardData = { ...response };
      const allWizardData = { ...state.allWizardData, ...response };

      return {
        ...state,
        wizardData,
        allWizardData,
      };
    }

  GET_VEHICLES_API_REQUEST,
  GET_VEHICLES_API_SUCCESS,
  GET_VEHICLES_API_ERROR,
  SUBMIT_WIZARD_API_REQUEST,
  SUBMIT_WIZARD_API_SUCCESS,
  SUBMIT_WIZARD_API_ERROR,

    getVehiclesResponse: null,
  isGettingVehiclesPending: false,
  isGettingVehiclesError: false,
  isGettingVehiclesSuccess: false,
  getVehiclesError: null,
  vehicles: [],
  submitWizardResponse: null,
  isSubmittingWizardPending: false,
  isSubmittingWizardError: false,
  isSubmittingWizardSuccess: false,
  submitWizardError: null,

    case GET_VEHICLES_API_REQUEST:
      return {
        ...state,
        isGettingVehiclesPending: true,
        isGettingVehiclesError: false,
        isGettingVehiclesSuccess: false,
      };
    case GET_VEHICLES_API_SUCCESS: {
      const response = action.payload;
      const vehicles = response?.payload?.vehicles || [];
      return {
        ...state,
        isGettingVehiclesPending: false,
        isGettingVehiclesError: false,
        isGettingVehiclesSuccess: true,
        getVehiclesResponse: action.payload, // newProducts,
        vehicles,
      };
    }
    case GET_VEHICLES_API_ERROR:
      return {
        ...state,
        isGettingVehiclesPending: false,
        isGettingVehiclesError: true,
        isGettingVehiclesSuccess: false,
        getVehiclesError: action.payload,
      };

    case SUBMIT_WIZARD_API_REQUEST:
      return {
        ...state,
        isSubmittingWizardPending: true,
        isSubmittingWizardError: false,
        isSubmittingWizardSuccess: false,
      };
    case SUBMIT_WIZARD_API_SUCCESS: {
      const response = action.payload;

      return {
        ...state,
        isSubmittingWizardPending: false,
        isSubmittingWizardError: false,
        isSubmittingWizardSuccess: true,
        submitWizardResponse: response, // newProducts,
      };
    }
    case SUBMIT_WIZARD_API_ERROR:
      return {
        ...state,
        isSubmittingWizardPending: false,
        isSubmittingWizardError: true,
        isSubmittingWizardSuccess: false,
        submitWizardError: action.payload,
      };
      */

